export default{
  '1': '获取订单信息失败',
  '2': '获取支付二维码失败',
  '3': '正在跳转至paypal支付链接，请稍等',
  '4': '信息填写不能为空',
  '5': '开票成功',
  '6': '开票成功',
  '7': '不能为空',
  '8': '请输入正确的邮箱地址',
  '9': '提交成功',
  '10': '联系信息不正确，请修改',
  '11': '系统繁忙，请稍后再试',
  '12': '您的信息已收到，我们会尽快与您联系',
  '13': '获取相机详情失败',
  '14': '无法删除最后的商品',
  '15': '确定删除吗？',
  '16': '请同意条款',
  '17': '请先保存发票信息',
  '18': '请先保存收货信息',
  '19': '请完善收货信息',
  '20': '请完善发票信息',
  '21': '请输入18位的税务登记号',
  '22': '请输入正确的手机号码',
  '23': '注册成功，是否立刻登录？',
  '24': '密码修改成功，请重新登录',
  '25': '没有找到相应的记录',
  '26': '确定要解绑当前相机吗？',
  '27': '上传的图片类型不正确，请重新上传',
  '28': '您的云端容量已用完，请删除其他场景或扩容， 以保证足够的容量。',
  '29': '手机号码不合法',
  '30': '请重新登录',
  '31': '密码位数不能少于8位',
  '32': '密码修改成功',
  '33': '解绑成功',
  '34': '失败',
  '35': '昵称不能为空',
  '36': '上传的图片类型不正确，请重新上传',
  '37': '删除成功',
  '38': '删除失败',
  '39': '商品加入购物车成功',
  '40': '请登录您的用户账号，再进行充值续费。',
  '41': '去登录',
  '42': '暂不支持降级套餐，您可进行续费或升级套餐。',
  '43': '请绑定用户账号后，进行充值扩容。',

  '4007': '用户名不存在',
  '4010': '绑定的相机不存在',
  '4011': '相机已经被绑定',
  '4012': '账号或密码错误',
  '7001': '标题包含敏感词',
  '7002': '内容包含敏感词',
  '6001': '物理地址重复',
  '6002': '退充值超过了充值总额',
  '6003': '相机不存在',
  '6004': '表示相机的点数超过了10万',
  '6006': '不支持重复绑定',
  '6009': 'data.fdage文件不存在',
  '6010': '该序列号已被绑定',
  '3001': '缺少必要参数',
  '3002': '访问异常！',
  '3003': '非法访问！',
  '3004': '请重新登录',
  '3005': '验证码已过期',
  '3006': '验证码错误',
  '3007': '昵称已存在',
  '3008': '该手机已被注册',
  '3009': '两次输入的密码不一致',
  '3010': '昵称长度在2-11位之间',
  '3011': '密码必须包含英文大小写、数字，长度8-16个字符',
  '3012': '昵称包含敏感词',
  '3013': '手机号码格式错误',
  '3014': '账号或密码不正确',
  '3015': '用户不存在',
  '3016': '您没有权限，请联系管理员',
  '3017': '空文件',
  '3018': '需要上传或使用的文件不存在',
  '3019': '邮箱格式不正确',
  '8001': '订单不存在',
  '8002': '支付失败',
  '5001': 'modeldata.json为空',
  '5002': 'order值为空',
  '5003': 'guideSid或order值为空',
  '5004': 'guideSid或guideName值为空',
  '5005': '场景为空',
  '5006': '余额不足',
  '5007': '非八目场景',
  '5008': '该场景已经被封存，无法删除',
  '5009': '场景被删除',
  '5010': '场景不属于该相机',
  '5011': '创建',
  '5012': '数据不正常',
  '5013': '场景对应的用户名为空',
  '5014': '该用户无权操作该场景',
  '5015': '该场景不属于当前登录账号',
  '5016': '热点外链场景不对'
}



// WEBPACK FOOTER //
// ./src/store/language/cn/toast.js